import React from 'react';
import PropTypes from 'prop-types';
import './loading-icon.scss';

/* eslint-disable max-len */
const LoadingIcon = ({ className, testId }) => (
  <svg className={ className ? 'bb-loading-icon ' + className : 'bb-loading-icon' }
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    data-cy={ testId || 'loading-icon' }
    style={{ backgroundImage: 'none', backgroundPosition: 'initial initial', backgroundRepeat: 'initial initial' }}>
    <path ng-attr-d="{{config.pathCmd}}" ng-attr-fill="{{config.color}}" stroke="none" d="M10 50A40 40 0 0 0 90 50A40 43 0 0 1 10 50"><animateTransform attributeName="transform" type="rotate" calcMode="linear" values="0 50 51.5;360 50 51.5" keyTimes="0;1" dur="1s" begin="0s" repeatCount="indefinite"></animateTransform></path>
  </svg>
);

LoadingIcon.propTypes = {
  className: PropTypes.string,
  testId: PropTypes.string
};

export default LoadingIcon;
